import React, { Component } from 'react';
import TextWithFieldname from '../texts/TextWithFieldname';
import IconRender from '../std/IconRender';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min";
import HelperGenerics from '../../helpers/HelperGenerics';

class DetailsButton extends Component {

	componentDidMount() {
		const tooltipTriggerNode = document.querySelector(`#veh_${HelperGenerics.rebuildWord(this.props.configurationKey)}_detail_button`);
		if (tooltipTriggerNode) {
			new bootstrap.Tooltip(tooltipTriggerNode);
		}
	}

	handleOpen = () => {
		if (this.props.vehicleDetailsIn == null) {
			this.props.onOpen(this.props.vehicle);
		}
	};

	handleBBCode(text) {
		if (text != null && text.includes('[b]') && text.includes('[/b]')) {
			var newtext = text.replace('[b]', '');
			newtext = newtext.replace('[/b]', '');
			return <strong>{newtext}</strong>;
		}
		return text;
	}
	render() {
		const isDetailLabel = this.props.detailLabel && this.props.detailLabel.length>0;
		const bbCodeDetailLabel = isDetailLabel ? this.handleBBCode(this.props.detailLabel) : " ";
		return (
			<span data-bs-toggle="modal" data-bs-target="#modalDetail">
				{this.props.text != null && this.props.detailOpenText === 'true' &&
					<button className='btn btn-link' onClick={() => { this.handleOpen() }}>
						{this.props.text}
					</button>
				}
				{((this.props.showCtaText === false || this.props.showCtaText === undefined) && this.props.detailOpenText === undefined) &&
					<button className='btn btn-link' onClick={() => { this.handleOpen() }}
						data-bs-toggle={isDetailLabel && "tooltip"}
						id={`veh_${HelperGenerics.rebuildWord(this.props.configurationKey)}_detail_button`}
						data-bs-title={bbCodeDetailLabel} title={bbCodeDetailLabel}
					>
						<IconRender name="info-circle-fill" />
					</button>
				}
				{this.props.showCtaText === true && this.props.detailOpenText === undefined &&
					<TextWithFieldname fieldname="callToAction" developperView={this.props.settings.developperView}>
						<button className='btn btn-link' onClick={() => { this.handleOpen() }}>
							{this.handleBBCode(this.props.detailLabel)}
						</button>
					</TextWithFieldname>
				}
			</span>
		)
	}
}

export default (DetailsButton)

